import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const workbalance = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
